/**
 * MrShoes mega menu — reliable tab switching + backdrop sync with Horizon header-menu.
 * Backdrop is visual-only (never captures pointer events).
 */

const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');

function ensureBackdrop() {
  document.querySelector('body > .c-mega-backdrop')?.remove();

  const container = document.querySelector('.header-section') || document.body;
  let backdrop = container.querySelector(':scope > .c-mega-backdrop');

  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'c-mega-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    container.insertBefore(backdrop, container.firstChild);
  }

  return backdrop;
}

function isMegaOpen() {
  const item = document.querySelector('.menu-list__list-item:has(.c-mega)');
  if (!item) return false;

  const link = item.querySelector('.menu-list__link[aria-haspopup]');
  const submenu = item.querySelector('.menu-list__submenu');

  return link?.getAttribute('aria-expanded') === 'true' || submenu?.hasAttribute('data-active');
}

function syncBackdrop(backdrop) {
  const open = isMegaOpen();
  backdrop.classList.toggle('is-active', open);
  backdrop.setAttribute('aria-hidden', open ? 'false' : 'true');
  document.documentElement.classList.toggle('c-mega-open', open);
}

function activatePanel(tabs, panels, tab) {
  const panelId = tab.dataset.panelId;
  if (!panelId) return;

  tabs.forEach((item) => {
    const active = item === tab;
    item.classList.toggle('is-active', active);
    item.setAttribute('aria-selected', active ? 'true' : 'false');
  });

  panels.forEach((panel) => {
    const active = panel.id === panelId;
    panel.classList.toggle('is-active', active);
    panel.setAttribute('aria-hidden', active ? 'false' : 'true');
  });
}



function initMegaTabs(mega) {
  if (mega.dataset.cMegaTabsReady === 'true') return;
  mega.dataset.cMegaTabsReady = 'true';

  const tabs = [...mega.querySelectorAll('[data-c-mega-tab]')];
  const panels = [...mega.querySelectorAll('[data-c-mega-panel]')];
  if (!tabs.length) return;

  tabs.forEach((tab) => {
    const onSelect = (event) => {
      // Desktop click follows the tab href; hover already switched the panel.
      if (event.type === 'click' && (FINE_POINTER.matches || tab.matches('a[href]'))) return;
      activatePanel(tabs, panels, tab);
    };

    tab.addEventListener('pointerenter', onSelect);
    tab.addEventListener('focus', onSelect);
    tab.addEventListener('click', onSelect);
  });
}

function initMegaMenu(root = document) {
  const scope = root instanceof Element ? root : document;
  scope.querySelectorAll('[data-c-mega]').forEach(initMegaTabs);
}

function initBackdropSync() {
  const backdrop = ensureBackdrop();
  if (document.documentElement.dataset.cMegaBackdropReady === 'true') return;
  document.documentElement.dataset.cMegaBackdropReady = 'true';

  syncBackdrop(backdrop);

  const headerMenu = document.querySelector('header-menu');
  if (headerMenu) {
    const observer = new MutationObserver(() => syncBackdrop(backdrop));
    observer.observe(headerMenu, {
      attributes: true,
      subtree: true,
      attributeFilter: ['aria-expanded', 'data-active'],
    });
  }

  document.addEventListener(
    'focusin',
    () => {
      window.requestAnimationFrame(() => syncBackdrop(backdrop));
    },
    true
  );
}

function initHeaderScroll() {
  const header = document.getElementById('header-component');
  if (!header || header.dataset.cHeaderScrollReady === 'true') return;

  header.dataset.cHeaderScrollReady = 'true';

  const onScroll = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 40);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

function initAll(root = document) {
  initMegaMenu(root);
  initBackdropSync();
  initHeaderScroll();
}

initAll(document);

document.addEventListener('shopify:section:load', (event) => {
  initAll(event.target);
});
